import { Link, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import "./Header.css";

function Header() {

  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > window.innerHeight - 100);
    };
    window.addEventListener("scroll", handleScroll);
  }, []);

  return (
    <header className={`fixed w-full z-50 transition-all duration-500 ${
      scrolled
        ? "bg-white/80 backdrop-blur-lg shadow-md"
        : "bg-black/40 backdrop-blur-sm"
    }`}>

      <div className="max-w-7xl mx-auto px-6 py-5 flex justify-between items-center">

        <Link
          to="/"
          className={`text-4xl font-bold tracking-wide flex items-center gap-1 logo-great ${
            scrolled ? "text-luxury-dark" : "text-white"
          }`}
        >
          <span className="logo-my">My</span>
          <span className="logo-trip">Trip</span>
        </Link>

        {/* Desktop Menu */}
        <nav className="hidden md:flex items-center font-medium">

          {[
            { name: "Home", path: "/" },
            { name: "About", path: "/about" },
            { name: "FAQ", path: "/faq" },
            { name: "Hotels", path: "/hotels" },
            { name: "Restaurants", path: "/restaurants" },
            { name: "Contact", path: "/contact" }
          ].map((item, i, arr) => {
            const path = item.path;
            const isLast = i === arr.length - 1;
            return (
              <div key={i} className="flex items-center">
                <Link
                  to={path}
                  className={`relative transition duration-300 menu-link ${
                    scrolled
                      ? "text-gray-800 hover:text-luxury-gold"
                      : "text-white hover:text-luxury-gold drop-shadow-md"
                  } ${location.pathname === path ? 'active' : ''}`}
                >
                  {item.name}
                </Link>
                {!isLast && (
                  <div className={`mx-4 h-6 w-px ${
                    scrolled ? "bg-gray-400" : "bg-white/60"
                  }`}></div>
                )}
              </div>
            );
          })}

        </nav>

        {/* Mobile Button */}
        <button
          onClick={() => setOpen(!open)}
          className={`md:hidden text-2xl transition-colors duration-300 ${
            scrolled ? "text-gray-800 hover:text-orange-500" : "text-white hover:text-orange-500"
          }`}
          aria-label="Toggle mobile menu"
        >
          {open ? '✕' : '☰'}
        </button>

      </div>

      {/* Mobile Menu */}
      <div
        className={`md:hidden overflow-hidden transition-all duration-500 ease-in-out ${
          open ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        <div className="bg-white/95 backdrop-blur-lg shadow-xl border-t border-gray-200 px-6 py-6">
          <nav className="flex flex-col space-y-1">
            {[
              { name: "Home", path: "/" },
              { name: "About", path: "/about" },
              { name: "FAQ", path: "/faq" },
              { name: "Hotels", path: "/hotels" },
              { name: "Restaurants", path: "/restaurants" },
              { name: "Contact", path: "/contact" },
              { name: "Privacy Policy", path: "/privacy-policy" },
              { name: "Terms of Service", path: "/terms-of-service" }
            ].map((item, i) => (
              <Link
                key={i}
                to={item.path}
                onClick={() => setOpen(false)}
                className={`relative py-3 px-4 rounded-lg transition-all duration-300 text-lg font-medium ${
                  location.pathname === item.path
                    ? 'bg-orange-50 text-orange-600 font-semibold border-l-4 border-orange-500'
                    : 'text-gray-700 hover:bg-gray-50 hover:text-orange-500 hover:translate-x-1'
                }`}
              >
                {item.name}
              </Link>
            ))}
          </nav>
        </div>
      </div>

    </header>
  );
}

export default Header;
